import { useEffect } from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useDateRangesInputContext } from './DateRangesInput.context';
import { Cancel } from '@mui/icons-material';
import { Tooltip, IconButton, Divider, Grid } from '@mui/material';
import moment from 'moment';

export const DateRangeStepper = () => {
  const {
    setShowInstructions,
    activeStep,
    setActiveStep,
    dateRanges,
    activeDateRange,
  } = useDateRangesInputContext();

  const steps: {
    [key: string]: { label: string; description: string; caption?: string }[];
  } = {
    default: [
      {
        label: 'Select a date range on the calendar',
        // caption: 'here is a caption',
        description: `Click a start date and end date to create the date range. You can change months by clicking the (>).`,
      },
      {
        label: 'Optional: Add another date range',
        description: `You can add another date range by clicking (+ Add another date range).`,
      },
      {
        label: 'Modify or delete date range',
        // caption: '',
        description: `You can edit your date range by clicking on the range and selecting new dates. You can delete by clicking the (x).`,
      },
    ],
    reply:
      dateRanges?.default?.length > 0 &&
      dateRanges?.default?.[0]?.start &&
      moment(dateRanges?.default?.[0]?.start).isValid()
        ? [
            {
              label: 'Select your dates for each available range',
              // caption: 'here is a caption',
              description: `Click on a date range to display it on the calendar. Then click the start and end date within that range.`,
            },
            {
              label: 'Modify or delete date range',
              // caption: '',
              description: `You can edit your date range by clicking on the range and selecting new dates. You can delete by clicking the (x).`,
            },
            {
              label: 'Suggest new dates',
              caption: 'If suggested ranges are unavailable',
              description: ` If you are not available for the provided date range(s), you can suggest new dates by clicking  (+ Suggest New Dates.)`,
            },
          ]
        : [
            {
              label: 'Suggest dates',
              // caption: 'If suggested ranges are unavailable',
              description: ` Click start and end dates to specify a range. You can suggest additional dates by clicking  (+ Suggest New Dates.)`,
            },
          ],
  };

  useEffect(() => {
    if (activeDateRange.mode === 'default') {
      if (
        dateRanges.default.length === 0 ||
        (dateRanges.default.length >= 0 &&
          (!dateRanges.default[0].start || !dateRanges.default[0].end))
      ) {
        setActiveStep(0);
      } else if (
        dateRanges.default.length === 1 &&
        dateRanges.default[0].start &&
        dateRanges.default[0].end
      ) {
        setActiveStep(1);
      } else if (
        dateRanges.default.length > 1 &&
        dateRanges.default[1].start &&
        dateRanges.default[1].end
      ) {
        setActiveStep(2);
      }
    } else if (activeDateRange.mode === 'reply') {
      if (
        dateRanges?.default?.length > 0 &&
        dateRanges?.default?.[0]?.start &&
        moment(dateRanges?.default?.[0]?.start).isValid()
      ) {
        setActiveStep(0);
      } else {
        setActiveStep(0);
      }
    } else {
      if (
        dateRanges?.default?.length > 0 &&
        dateRanges?.default?.[0]?.start &&
        moment(dateRanges?.default?.[0]?.start).isValid()
      ) {
        setActiveStep(2);
      } else {
        setActiveStep(0);
      }
    }
  }, [dateRanges, activeDateRange]);
  return (
    <Box
      sx={{
        maxWidth: 400,
        border: theme => `1px solid ${theme.palette.divider}`,
        p: 1,
        borderRadius: '4px',
        mr: 2,
      }}
    >
      <Typography variant="overline" sx={{ color: '#203A3E' }}>
        Help Center
      </Typography>
      <Tooltip title="Close help center" placement={'left'} arrow>
        <IconButton
          onClick={() => {
            setShowInstructions(false);
          }}
          sx={{ float: 'right' }}
        >
          <Cancel
            sx={{
              // color: theme => theme.palette.common.white,
              fontSize: { xs: 12, sm: 18 },
            }}
          />
        </IconButton>
      </Tooltip>
      <Divider />
      <Stepper activeStep={activeStep} orientation="vertical" nonLinear={true}>
        {steps[
          activeDateRange.mode !== 'suggest' ? activeDateRange.mode : 'reply'
        ]?.map((step, index) => (
          <Step
            key={step.label}
            onClick={() => setActiveStep(index)}
            sx={{ cursor: 'pointer' }}
          >
            <StepLabel
              optional={
                step.caption ? (
                  <Typography variant="caption">{step.caption}</Typography>
                ) : null
              }
            >
              {step.label}
            </StepLabel>
            <StepContent>
              <Typography>{step.description}</Typography>
              {/* <Box sx={{ mb: 2 }}>
                <div>
                  <Button
                    variant="contained"
                    onClick={handleNext}
                    sx={{ mt: 1, mr: 1 }}
                  >
                    {index === steps.length - 1 ? 'Finish' : 'Continue'}
                  </Button>
                  <Button
                    disabled={index === 0}
                    onClick={handleBack}
                    sx={{ mt: 1, mr: 1 }}
                  >
                    Back
                  </Button>
                </div>
              </Box> */}
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};
